import axios from "axios";
import { getUrlVars } from "../utils/data";
class adesisServices {
  constructor() {
    this.service = axios.create({
      baseURL: process.env.REACT_APP_SERVICE_ADESIS_URL,
    });
    this.getUrlParams();
  }

  dealers = [];
  param = null;
  getKmMantenimiento = (fullKatashiki, gearBoxName, year, nEngine) => {
    return this.service
      .get(
        `/calcMant/GetKmMantenimiento?cFullKatashiki=${fullKatashiki}&cTipoDeCambio=${gearBoxName}&nAnoProduccion=${year}&cMotor=${nEngine}`
      )
      .then((response) => response)
      .catch((e) => console.log(e));
  };

  getWorkshops = () => {
    return this.service
      .get(
        `/Concesionario/GetConcesionariosByActivity?bMecanica=1&bChapa=0&bRepuestos=0`
      )
      .then((response) => {
        this.dealers = response.data;
        document.getElementsByTagName("div")[
          document.getElementsByTagName("div").length - 1
        ].textContent = "";
        return response;
      })
      .catch((e) => console.log(e));
  };

  getBudeget = (
    fullKatashiki,
    year,
    gearBoxName,
    // nIdConcesionario,
    // nIdLocalizacion,
    unitHourPrice,
    distanceSelected,
    nIdCombustible,
    nEngine
  ) => {
    return this.service
      .get(
        // `/calcMant/GetCostTimeAndTypes?cFullKatashiki=${fullKatashiki}&nAnoProduccion=${year}&cTipoDeCambio=${gearBoxName}&nIdConcesionario=${nIdConcesionario}&nIdLocalizacion=${nIdLocalizacion}&cKmMantenimiento=${distanceSelected}k&nIdCombustible=${nIdCombustible}&cMotor=${nEngine}`
        `/calcMant/GetCostTimeAndTypes?cFullKatashiki=${fullKatashiki}&nAnoProduccion=${year}&cTipoDeCambio=${gearBoxName}&cPrecioTaller=${unitHourPrice}&cKmMantenimiento=${distanceSelected}k&nIdCombustible=${nIdCombustible}&cMotor=${nEngine}`
      )
      .then((response) => response)
      .catch((e) => console.log(e));
  };

  getFuel = (arr) => {
    console.log('fullKatashikis: ', arr)
    return this.service
      .get(`/calcMant/GetTiposCombustibles`, {
        params: { fullKatashikis: JSON.stringify(arr) },
      })
      .then((response) => response)
      .catch((e) => console.log(e));
  };

  getUnitHourPrice = (dealerId) => {
    return this.service
      .get(
        `/calcMant/GetWorkshopPrice?dealerId=${dealerId}`
      )
      .then((response) => response);
  };

  sendMail = (sendEmaildata) => {
    return this.service
      .post(`/EmailTemplate/SendMailTemplateMantenimiento`, sendEmaildata)
      .then((response) => response)
      .catch((e) => console.log(e));
  };

  getPkPass = (walletObjectData) => {
    return this.service
      .post(`/PkPass/CalculadoraMantenimientoEventTicket`, walletObjectData)
      .then((response) => response)
      .catch((e) => console.log(e));
  };
  getUrlParams = () => {
    this.param = getUrlVars()["dealer"];
    // console.log(this.param);
  };
}

export default adesisServices;
